import {RED_COLOUR, ORANGE_MID_COLOUR, DARK_YELLOW_COLOUR, GREEN_LIGHT_COLOUR, GREEN_COLOUR} from '@/constants/colours'

const ROOT_RELATIVE_PATH = '/static-appopensalud/img/icons/emojis/'

/**
 * Registro “global” de iconos para moods, presiones,…
 * Las claves son strings semánticos que puedas elegir luego.
 */
const registry = {
  verySad:    { src: `${ROOT_RELATIVE_PATH}emoji-very-sad.svg`, color: RED_COLOUR },
  sad:    { src: `${ROOT_RELATIVE_PATH}emoji-sad.svg`, color: ORANGE_MID_COLOUR },
  noFeelings: { src: `${ROOT_RELATIVE_PATH}emoji-no-feelings.svg`, color: DARK_YELLOW_COLOUR },
  semiHappy:      { src: `${ROOT_RELATIVE_PATH}emoji-semi-happy.svg`, color: GREEN_LIGHT_COLOUR },
  happy:    { src: `${ROOT_RELATIVE_PATH}emoji-happy.svg`, color: GREEN_COLOUR},
  // …añade tantos como quieras
}

/**
 * Registra (o sobreescribe) iconos dinámicamente.
 * exporta todos los que declares aquí y en registry.
 */
export function registerTickIcons(newIcons = {}) {
  Object.assign(registry, newIcons)
}

/**
 * Devuelve el icono (src + color) para la clave dada, o null.
 * @param {string} key
 */
export function getTickIcon(key) {
  return registry[key] || null
}

/**
 * Genera el HTML de un <span> con máscara y color adecuados.
 * @param {string} key    — clave semántica del icono
 * @param {number} [size=22] — tamaño en px (width/height)
 * @returns {string}         — HTML listo para useHTML
 */
export function renderTickIconHtml(key, size = 22) {
  const icon = getTickIcon(key)
  if (!icon) return ''  // o devuelve key si quieres fallback numérico/textual
  return `<span
    style="
      display:inline-block;
      width:${size}px;
      height:${size}px;
      background-color:${icon.color};
      -webkit-mask:url('${icon.src}') center/contain no-repeat;
      mask:url('${icon.src}') center/contain no-repeat;
    ">
  </span>`
}

/**
 * Dado un array de claves, devuelve un array de icon objects [{src,color},…]
 * @param {string[]} keys
 */
export function getTickIcons(keys = []) {
  return keys
    .map(k => getTickIcon(k))
    .filter(icon => icon !== null)
}

export function getMoodEmojiKey(value) {
  if (value <= 2) return 'verySad'
  if (value <= 4) return 'sad'
  if (value <= 6) return 'noFeelings'
  if (value <= 8) return 'semiHappy'
  return 'happy'
}



// WEBPACK FOOTER //
// ./src/helpers/icon.helpers.js